import { render, staticRenderFns } from "./EditGroupAttribute.vue?vue&type=template&id=54f7f458&scoped=true&"
import script from "./EditGroupAttribute.vue?vue&type=script&lang=js&"
export * from "./EditGroupAttribute.vue?vue&type=script&lang=js&"
import style0 from "./EditGroupAttribute.vue?vue&type=style&index=0&id=54f7f458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f7f458",
  null
  
)

export default component.exports